import { render } from "./authenticationCenter.vue?vue&type=template&id=72e8c794&scoped=true"
import script from "./authenticationCenter.vue?vue&type=script&lang=js"
export * from "./authenticationCenter.vue?vue&type=script&lang=js"

import "./authenticationCenter.vue?vue&type=style&index=0&id=72e8c794&lang=scss&scoped=true"

import exportComponent from "D:\\GitLocal\\mvs-sys\\mvsui-user\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72e8c794"]])

export default __exports__